import React from 'react';
import usePlaylistsByCategory from 'sdk/hooks/usePlaylistsByCategory';
import SelectWithModal from 'components/shared/SelectWithModal';

function PlaylistSelect({
  value, onChange, categoryId, placeholder, className,
}: {
  value: any,
  onChange: (v: any) => void,
  categoryId: number,
  placeholder?: string
  className?: string
}) {
  const playlistData = usePlaylistsByCategory(categoryId, 'creator')

  return (
    <SelectWithModal
      className={className}
      options={(playlistData.data || [])}
      title="Playlist"
      onSelect={onChange}
      multiple
      value={value}
      isSearchable
      placeholder={placeholder}
      disabled={!categoryId}
      maxLength={2}
    />
  )
}

export default PlaylistSelect
